import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ImageItem } from '../image-gallery/image-gallery.component';

@Component({
  selector: 'app-image-carousel-dialog',
  templateUrl: './image-carousel-dialog.component.html',
  styleUrls: ['./image-carousel-dialog.component.scss']
})
export class ImageCarouselDialogComponent {
    currentIndex = 0;

    constructor(
        @Inject(MAT_DIALOG_DATA) public images: ImageItem[],
        private dialogRef: MatDialogRef<ImageCarouselDialogComponent>
    ) {}

    prevImage(): void {
        this.currentIndex =
            (this.currentIndex - 1 + this.images.length) % this.images.length;
    }

    nextImage(): void {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
    }

    close(): void {
        this.dialogRef.close();
    }
}
